<dx-toolbar class="toolbar">
  <dxi-item
    location="before"
    widget="dxButton"
    locateInMenu="never"
    [options]="detailsLayoutButtonOptions"
  >
  </dxi-item>
  <dxi-item
    location="before"
    widget="dxTextBox"
    locateInMenu="never"
    style=" padding-inline: 10px"
  >{{ formType }}
  </dxi-item>
  <dxi-item
    *ngIf="formCode"
    location="before"
    widget="dxTextBox"
    locateInMenu="auto"
    style="border-inline: 1px solid; padding-inline: 10px"
  >{{ getFormName(formCode) }}
  </dxi-item>
  <dxi-item
    *ngIf="this.isShowLastActions || formMetaData.detayTakipYn "
    #btnLastActionsTarget
    id="btnLastActionsTarget"
    location="before"
    widget="dxButton"
    locateInMenu="never"
    [options]="lastActionsButtonOptions"
  >
  </dxi-item>
  <dxi-item
    *ngIf="listAction"
    location="before"
    widget="dxTextBox"
    locateInMenu="never"
    style="border-right: 1px solid; padding-inline: 10px"
  >{{ listAction }}
  </dxi-item>
  <dxi-item
    *ngIf="auditInfo"
    location="before"
    widget="dxTextBox"
    locateInMenu="never"
    style="border-inline: 1px solid; padding-inline: 10px; white-space: nowrap; font-weight: bold; color: #0a1a4a;"
  >Oluşturan: {{ auditInfo.kayitKullanici || '-' }} ({{ (auditInfo.kayitTarih | date:'dd.MM.yyyy HH:mm') || '-' }}) | Güncelleyen: {{ auditInfo.degisKullanici || '-' }} ({{ (auditInfo.degisTarih | date:'dd.MM.yyyy HH:mm') || '-' }})
  </dxi-item>

  <dxi-item location="center" widget="dxButton" locateInMenu="never">
    <div *dxTemplate>
      <div class="toolbar-label"><b>Dabnet</b></div>
    </div>
  </dxi-item>

  <dxi-item
    location="after"
    widget="dxButton"
    locateInMenu="never"
    [options]="toastMessageButtonOptions"
  >
  </dxi-item>


  <dxi-item
    id="btnHelp"
    location="after"
    widget="dxButton"
    locateInMenu="never"
    [options]="helpButtonOptions"
  >
  </dxi-item>

  <dxi-item
    id="btnLogFormIslem"
    location="after"
    widget="dxButton"
    locateInMenu="never"
    [options]="logFormIslemButtonOptions"
  >
  </dxi-item>

</dx-toolbar>

<ng-container *ngIf="helpPopupVisible">
  <dk-form-popup
    [popupName]="'DestekTalepForm'"
    [formMetada]="formMetaData"
    [state]="'New'"
    [width]="'30%'"
    [visible]="helpPopupVisible"
    (visibleChange)="helpPopupVisible = $event"
    [title]="'Destek Talebi Aç'"
  >
    <!-- DKM-1078 Cedric: eski hâli — çoğu ekran formMetaData geçirmediği için talebin ekranı kayboluyordu -->
    <!-- <dk-dk-list-help-form [formMetaData]="formMetaData" (closePopup)="closeHelpForm($event)"></dk-dk-list-help-form> -->
    <dk-dk-list-help-form
      [formMetaData]="formMetaData"
      [formCode]="formCode"
      [recordData]="recordData"
      (closePopup)="closeHelpForm($event)"
    ></dk-dk-list-help-form>
  </dk-form-popup>
</ng-container>

<dx-action-sheet
  [items]="actionSheetDataSource"
  [(visible)]="actionSheetVisible"
  (onItemClick)="handleActionSheetSelection($event)"
  [title]="'Son İşlemler Listesi'"
  [width]="380"
  [target]="actionSheetTarget"
  [usePopover]="true"
>
</dx-action-sheet>

<ng-container *ngIf="logFormIslemPopupVisible">
  <dx-popup
    height="82%"
    width="80%"
    [showTitle]="true"
    [position]="'center'"
    [title]="'Form İşlem Logları'"
    [resizeEnabled]="true"
    [hideOnOutsideClick]="false"
    [showCloseButton]="true"
    [(visible)]="logFormIslemPopupVisible"
  >
    <dk-log-form-islem [formCode]="formCode"></dk-log-form-islem>
  </dx-popup>
</ng-container>

